'use client';

import { useEffect, useRef } from "react";
import gsap from "gsap";

/**
 * Floating decorative element component
 * Adds a subtle floating animation to decorative elements
 */
export function FloatingElement() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      gsap.to(containerRef.current, {
        y: -10,
        duration: 2,
        repeat: -1,
        yoyo: true,
        ease: "sine.inOut"
      });
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className="absolute bottom-10 right-10 opacity-50 hidden lg:block"
    >
      <div className="w-24 h-24 rounded-full bg-gradient-to-r from-primary/30 to-secondary/30 blur-xl" />
    </div>
  );
} 